import { Box, Typography } from '@mui/material';

import CustomDialog from 'src/components/custom-dialog/custom-dialog';
import CustomTableCell from 'src/components/custom-table-cell/custom-table-cell';
import DataTable from 'src/components/data-table/data-table';

import CategoryCollapse from '../category-collapse/category-collapse';
import Filter from '../filter/filter';
import { useCategories } from './categories-hook';

export interface CategoriesProps {}

function RowConfig({ row }: { row: any }) {
  return (
    <>
      <CustomTableCell borderLeft>
        <Typography typography="body-md">{row?.name || 'Categoria'}</Typography>
      </CustomTableCell>
      <CustomTableCell>
        <Typography typography="body-md">
          {(() => {
            const labels: Record<string, string> = {
              stores: 'Lojas',
              restaurant: 'Restaurantes',
              service: 'Serviços',
              events: 'Eventos',
            };
            const types: string[] = row?.types?.length ? row.types : [row?.type].filter(Boolean);
            return types.map((type) => labels[type] || type).join(', ');
          })()}
        </Typography>
      </CustomTableCell>
      <CustomTableCell>
        <Typography typography="body-md">{row?.count || 0}</Typography>
      </CustomTableCell>
    </>
  );
}

export default function Categories(Props: CategoriesProps) {
  const {
    isLoading,
    getData,
    handleAddNew,
    checked,
    createSortHandler,
    handleChangePage,
    handleChangeRowsPerPage,
    limit,
    order,
    orderBy,
    page,
    total,
    data,
    handleCheckRow,
    handleConfirmDelete,
    handleDelete,
    useConfirmDeleteDialog,
  } = useCategories();

  return (
    <div data-testid="categories-render-test">
      <Filter getData={getData} handleAddNew={handleAddNew} />
      <Box height={32} />
      <DataTable
        collapseNewIdCondition="-"
        header={[
          { label: 'Ativar', id: 'status', sortable: true },
          { label: 'Categoria', id: 'name', sortable: true },
          { label: 'Tipo', id: 'type', sortable: true },
          { label: 'Benefícios', id: 'count', sortable: true },
        ]}
        rows={data}
        collapseConfig={(row) => <CategoryCollapse getData={getData} data={row} />}
        rowConfig={(row) => <RowConfig row={row} />}
        createSortHandler={createSortHandler}
        handleDelete={handleDelete}
        order={order}
        orderBy={orderBy}
        count={total}
        isLoading={isLoading}
        checked={checked}
        page={page}
        rowsPerPage={limit}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        setChecked={handleCheckRow}
      />
      {useConfirmDeleteDialog.value && (
        <CustomDialog
          open={useConfirmDeleteDialog.value}
          icon="alert-line"
          title="Atenção"
          content="Deseja mesmo deletar a categoria?"
          confirmText="Remover"
          cancelText="Cancelar"
          onConfirm={handleConfirmDelete}
          onClose={useConfirmDeleteDialog.onFalse}
        />
      )}
    </div>
  );
}
